export const focusButton = (buttonRef: React.RefObject<HTMLButtonElement>) => {
  setTimeout(() => {
    if (!buttonRef?.current?.disabled) {
      buttonRef?.current?.focus();
    }
  }, 0);
};
